export const formatErrors = (errors) =>
  Object.entries(errors)
    .map(([name, value]) => {
      if ("_errors" in value) {
        return `${name}: ${value._errors.join(", ")}\n`;
      }
      return null;
    })
    .filter(Boolean);
